import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: string;
  noIndex?: boolean;
}

export const SEOHead = ({
  title = "Processing Bros - Professional Payment Solutions",
  description = "Stop overpaying for credit card processing. Processing Bros offers transparent merchant services, cash discount programs, and POS systems with no hidden fees. Serving Fort Lauderdale and South Florida.",
  keywords = "credit card processing, merchant services, payment processing, cash discount program, POS systems, Fort Lauderdale, South Florida",
  image = "/processing-bros-icon-ios.png",
  type = "website",
  noIndex = false
}: SEOHeadProps) => {
  const location = useLocation();
  const canonicalUrl = `https://processingbros.com${location.pathname}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Robots Meta */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="Processing Bros" />
      <meta property="og:image" content={`https://processingbros.com${image}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://processingbros.com${image}`} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="author" content="Processing Bros" />
      <meta name="publisher" content="Processing Bros" />
      <meta name="copyright" content="Processing Bros" />
      <meta name="language" content="English" />
      <meta name="coverage" content="Worldwide" />
      <meta name="distribution" content="Global" />
      <meta name="rating" content="General" />
      
      {/* Mobile Optimization */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Processing Bros" />
      
      {/* Performance Hints */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />
      <link rel="preconnect" href="https://processingbros.com" />
    </Helmet>
  );
};

export default SEOHead;